const trackShortForm = (country, place) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'event',
      'eventCategory': 'Contact Form',
      'eventAction': 'submit form',
      'eventLabel': country + "-" + place,
      'eventNonInteraction': false
    });
  }
}

const trackLongForm = (country, place, type, pax, ownerCountry) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'event',
      'eventCategory': 'Contact Form',
      'eventAction': 'submit form',
      'eventLabel': country + "-" + place + "-" + type + "-" + pax + "-" + ownerCountry,
      'eventNonInteraction': false
    });
  }
}

const trackFormError = (fields) => {
  console.log(fields.map((field) => field + ' error').join(', '));
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'event',
      'eventCategory': 'Contact Form',
      'eventAction': 'error',
      'eventLabel': fields.map((field) => field + ' error').join(', '),
      'eventNonInteraction': false
    });
  }
}

// SHORT FORM
const partnerShortForms = document.querySelectorAll('form[data-name="owner-register-short"]');
partnerShortForms.forEach((form) => {
  const country = form.querySelector('#accommodation_country');
  const place = form.querySelector('#accommodation_city');

  form.addEventListener('submit', (e) => {
    document.body.classList.add('form-submitting');
    // const errors = checkShortForm(form);

    // if (errors.length === 0) {
      trackShortForm(country.value, place.value);
    // } else {
      // trackFormError(errors);
    // }
  });
});

function checkShortForm(form) {
  let errors = [];

  const fields = [
    'accommodation_country', 'accommodation_post_code', 'accommodation_city',
    'last_name', 'email'
  ];

  fields.forEach((field) => {
    const el = form.querySelector('#' + field);
    if (!el.value) {
      errors.push(field);
    }

    // if (field == 'email') {
    //   // Validating email address
    //   if (el.value.match(/^[a-z0-9+._@-]+$/i)) {
    //     errors.push(field);
    //   }
    // }
  });

  const salutationEl = document.querySelector('input[name="salutation"]:checked');
  if (!salutationEl) errors.push('salutation');

  const privacyEl = form.querySelector('#privacy');
  if (!privacyEl.checked) errors.push('privacy');

  return errors;
}

// LONG FORM
const partnerLongForms = document.querySelectorAll('form[data-name="owner-register-full"]');
partnerLongForms.forEach((form) => {
  const country = form.querySelector('#accommodation_country');
  const place = form.querySelector('#accommodation_city');
  const pax = form.querySelector('#bedrooms');
  const ownerCountry = form.querySelector('#country');

  form.addEventListener('submit', (e) => {
    const errors = checkLongForm(form);

    if (errors.length === 0) {
      const type = document.querySelector('input[name="accommodation_type"]:checked');

      trackLongForm(
        country.value,
        place.value,
        type ? type.value : '',
        pax.value,
        ownerCountry.value,
      );
    } else {
      trackFormError(errors);
    }
  });
});

function checkLongForm(form) {
  let errors = [];

  const fields = [
    'accommodation_country', 'accommodation_post_code', 'accommodation_city',
    'guest_no', 'bedrooms', 'last_name', 'address_line1', 'post_code', 'city', 'country',
    'lang_cust', 'email'
  ];

  fields.forEach((field) => {
    const el = form.querySelector('#' + field);
    if (!el.value) {
      errors.push(field);
    }

    if (field == 'email') {
      // Checking email address
    }
  });

  const typeEl = document.querySelector('input[name="accommodation_type"]:checked');
  if (!typeEl) errors.push('type');

  const salutationEl = document.querySelector('input[name="salutation"]:checked');
  if (!salutationEl) errors.push('salutation');



  const privacyEl = form.querySelector('#privacy');
  if (!privacyEl.checked) errors.push('privacy');

  return errors;
}
